import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Inventory_ds_get_available_inventory_by_materialIds_warehouseIds_batchedService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { materialIds: number[], warehouseIds: number[] }): 
  Promise<{ result: { TotalAvailablePackagedAmount?: number, TotalAvailableBaseAmount?: number, WarehouseId?: number, MaterialId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.materialIds)) {
      missingRequiredInParams.push('\'materialIds\'');
    }
    if (isNil(inParams.warehouseIds)) {
      missingRequiredInParams.push('\'warehouseIds\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Inventory/datasources/ds_get_available_inventory_by_materialIds_warehouseIds_batched/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { materialIds: number[], warehouseIds: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { TotalAvailablePackagedAmount?: number, TotalAvailableBaseAmount?: number, WarehouseId?: number, MaterialId?: number }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.materialIds)) {
      missingRequiredInParams.push('\'materialIds\'');
    }
    if (isNil(inParams.warehouseIds)) {
      missingRequiredInParams.push('\'warehouseIds\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Inventory/datasources/ds_get_available_inventory_by_materialIds_warehouseIds_batched/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { materialIds: number[], warehouseIds: number[], $keys: { WarehouseId?: number, MaterialId?: number }[] }): 
  Promise<{ result: { TotalAvailablePackagedAmount?: number, TotalAvailableBaseAmount?: number, WarehouseId?: number, MaterialId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.materialIds)) {
      missingRequiredInParams.push('\'materialIds\'');
    }
    if (isNil(inParams.warehouseIds)) {
      missingRequiredInParams.push('\'warehouseIds\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Inventory/datasources/ds_get_available_inventory_by_materialIds_warehouseIds_batched/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      materialIds: number[], warehouseIds: number[]    }) {
        if(isNil(inParams.materialIds)) {
          return true; 
        }
        if(isNil(inParams.warehouseIds)) {
          return true; 
        }
      return false;
    }
}
